"use client";

import { useEffect, useState } from "react";
import { DEFAULT_BRAND, getBrandFromWindow } from "@/lib/brand";

export function Logo() {
	const [logoSrc, setLogoSrc] = useState(DEFAULT_BRAND.logo);

	useEffect(() => {
		setLogoSrc(getBrandFromWindow().logo);
	}, []);

	return (
		<div>
			{/* biome-ignore lint/performance/noImgElement: Logo src is dynamic based on domain */}
			<img src={logoSrc} alt="Logo" className="max-w-[200px]" />
		</div>
	);
}
